import { v4 as uuidV4 } from 'uuid';
import React, { PropsWithChildren, useMemo } from 'react';
import { Tooltip as RSTooltip, Whisper } from 'rsuite';
import { createGlobalStyle } from 'styled-components';

export const TooltipGlobalStyle = createGlobalStyle`
  .rs-tooltip {
    padding: 6px 12px;
    background-color: ${({ theme }) => theme.colors.gray100};
    ${({ theme }) => theme.typescales.body6};
    font-size: 13px;
    color: ${({ theme }) => theme.colors.grayWhite};
    white-space: nowrap;
    max-width: none;
    word-break: keep-all;
    border-radius: 8px;
    opacity: 0.7;
    transition: opacity 0.6s ease-in-out, transform 0.6s ease-in-out;
  }
  .rs-anim-fade-in.rs-anim-in {
    opacity: 0.7;
  }
  .rs-anim-fade-in {
    opacity: 0;
    transition: opacity 0.6s ease-in-out;
  }
`;

interface TooltipProps extends PropsWithChildren {
  trigger?: 'hover' | 'click';
  placement?: 'top' | 'topEnd' | 'right' | 'bottom' | 'bottomStart' | 'bottomEnd';
  message: string | React.ReactNode;
}
const Tooltip: React.FC<TooltipProps> = ({
  trigger = 'click',
  placement = 'top',
  message,
  children,
}) => {
  const uuid = useMemo(() => uuidV4(), []);
  return (
    <Whisper
      trigger={trigger}
      placement={placement}
      controlId={uuid}
      speaker={<RSTooltip>{message}</RSTooltip>}>
      {children as any}
    </Whisper>
  );
};

export default Tooltip;
